import React, { useState, useEffect, useRef } from "react";
import FilterData from "./filterData";
import ShowData from "./showData";
import { Formik, Form, ErrorMessage, getIn } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { InsertData } from "../../../Service/service.goods";
import { swalSuccess, swalError } from "../../../Components/sweetAlert";
import { GetData } from "../../../Service/service.goods";
import { useTranslation } from "react-i18next";
import Modal from "react-bootstrap/Modal";
import { UpdateDimensions } from "../../../Service/service.goods";
import {calculatedPrice as calculatedPriceAPI, CheckDimensions} from "../../../Service/service.Parcels";
import { Tab, Tabs } from 'react-bootstrap';

function SaveGoods(props) {
  const { user } = props;
  // const inputs = useRef([]);
  const inputsRef = useRef([]);
  
  const dimensionSchema = Yup.object().shape({
    weight: Yup.number()
      .typeError('Weight must be a number')
      .positive('Weight must be greater than 0')
      .required('Weight is required'),
    box_length: Yup.number()
      .typeError('Length must be a number')
      .positive('Length must be greater than 0')
      .required('Length is required'),
    box_width: Yup.number()
      .typeError('Width must be a number')
      .positive('Width must be greater than 0')
      .required('Width is required'),
    box_height: Yup.number()
      .typeError('Height must be a number')
      .positive('Height must be greater than 0')
      .required('Height is required')
  });
  const schema = Yup.object().shape({
    items: Yup.array().of(dimensionSchema).nullable(),
    awbCode: Yup.string()
        .required("กรุณาระบุเลขบาร์โค้ด")
        // .min(16, 'ความยาวของบาร์โค้ดควรเป็น 16')
        // .max(16, 'ความยาวของบาร์โค้ดควรเป็น 16'),
  });
  const [shipmentStatus, setShipmentStatus] = useState("1");
  const [perPage, setPageSize] = useState(10);
  const [data, setData] = useState([]);
  const [page, setPage] = useState({
    current_page: 0,
    last_page: 1,
    total: 0,
  });
  const [pageNo, setCurrentPage] = useState(1);
  const [loading, Loading] = useState(0);
  const [errorMassNoData, setErrorMassNoData] = useState(0);

  const [weight,setWeight]= useState(0);
  const [box_width,setBox_width]= useState(0);
  const [box_height,setBox_height]= useState(0);
  const [box_length,setBox_length]= useState(0);
  const [listDimensions,SetListDimensions]= useState([]);
  const [activeTab, setActiveTab] = useState(0);

  const [disableSubmit, setDisableSubmit] = useState(false);
  const [priceLoading, setPriceLoading] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => {
    SetListDimensions([]);
    setShow(false);
  }
  const handleShow = () => {
    setShow(true);
    setTimeout(() => {
      if (inputsRef.current[0]) {
        inputsRef.current[0].focus();
        inputsRef.current[0].select();
      }
    }, 10);
    setActiveTab(0);
  }
  const [barcodeNumber, BarcodeNumber] = useState("");
  

  useEffect(() => {
    fetchData({
      shipmentStatus: shipmentStatus,
      empCode: user.username,
      pageNo: pageNo,
      perPage: perPage,
    });
  }, []);

  useEffect(() => {
    if (show && inputsRef.current[0]) {
      setTimeout(() => {
        inputsRef.current[0]?.focus();
        inputsRef.current[0]?.select();
      }, 100);
    }
  }, [show]);

  

  const calculatedPrice = async (size, weight, cod, district) => {
      setPriceLoading(true);
      try {
        const result = await calculatedPriceAPI(size, weight, cod, district);
        return result;
      }
      catch (error) {
        throw error;
      }
      finally {
        setPriceLoading(false);
      }
    };

    async function checkDimensionsMultiple(awb_code){
      const res = await CheckDimensions(awb_code);
      if (res.status === 1) {
        SetListDimensions(res?.data)
        return res?.data;
      } else {
        return [];
      }
    }

  async function fetchData(params) {
    Loading(1);
    let res = await GetData(params);
    if (res.numRowsAll > 0) {
      // const dataMerged = 
      // alert(res.result.map(item1 => ({ ...item1, ...res.sizes.find(item2 => item2.awb_code === item1.awb_code) })))
      // setData(res.result.map(item1 => ({ ...item1, ...res.sizes.find(item2 => item2.awb_code === item1.AWB_CODE) })));
      setData(res.result);
      setPage({
        current_page: res.pageNo,
        last_page: res.maxPage,
        total: res.numRowsAll,
      });
      setErrorMassNoData(0);
      Loading(0);
    } else {
      setCurrentPage(1);
      setPage({
        current_page: 1,
        last_page: 1,
        total: 0,
      });
      setErrorMassNoData(1);
      Loading(0);
    }
  }

  const handleChangeShipmentStatus = (e) => {
    setData([]);
    setErrorMassNoData([])
    setShipmentStatus(e);
    fetchData({
      shipmentStatus: e,
      empCode: user.username,
      pageNo: pageNo,
      perPage: perPage,
    });
  };

  const handleChangePageSize = (e) => {
    setData([]);
    setErrorMassNoData([])
    setPageSize(e);
    fetchData({
      shipmentStatus: shipmentStatus,
      empCode: user.username,
      pageNo: pageNo,
      perPage: e,
    });
  };

  const handleChangePage = (e, newPage) => {
    setData([]);
    setErrorMassNoData([])
    setCurrentPage(newPage);
    fetchData({
      shipmentStatus: shipmentStatus,
      empCode: user.username,
      pageNo: newPage,
      perPage: perPage,
    });
  };
  const { t } = useTranslation();

  async function updateDimensionsMultiple(data) {
    console.log("date Update", data)
      try {
        let result = await UpdateDimensions(data);
        if (result.status === 0) {
          swalError();
        } else {
          setData([]);
          setErrorMassNoData([])
          fetchData({
            shipmentStatus: shipmentStatus,
            empCode: user.username,
            pageNo: pageNo,
            perPage: perPage,
          });
      }
    }
    catch (e) {
      swalError({
        text: t(e.response.data.message),
      });
    }
  }

  async function insertData(params) {
    console.log("params", params)
      try {
        let result = await InsertData(params);
        if (result.status === 0) {
          swalError();
        } else {
          setData([]);
          setErrorMassNoData([])
          fetchData({
            shipmentStatus: shipmentStatus,
            empCode: user.username,
            pageNo: pageNo,
            perPage: perPage,
          });
      }
    }
    catch (e) {
      swalError({
        text: t(e.response.data.message),
      });
    }
  }

  return (
    <>
      <Formik
        validationSchema={schema}
        initialValues={{
          awbCode: "",
          shipmentStatus: shipmentStatus,
          empCode: user.username,
          items: listDimensions
        }}
        onSubmit={async (value, { setFieldValue }) => {
          value.empCode = user.username;
          //edit dimensions
          // if(value.shipmentStatus=="1"){
          //   const val = await checkDimensionsMultiple(value.awbCode);
          //   setFieldValue("items",val);
          //   // alert(JSON.stringify(val));
          //   if(Array.isArray(val) && val?.length===0 && localStorage.getItem("showEditDimensions")!=='1'){
          //     insertData(value);
          //     value.awbCode = ""
          //     document.getElementById("awbCode").value = "";
          //     handleClose();
          //   }
          //   else if(Array.isArray(val) && val?.length!==0 && localStorage.getItem("showEditDimensions")==='1') {
          //     handleShow();            
          //   }
          // }
          // else {
            insertData(value);
            value.awbCode = ""
            document.getElementById("awbCode").value = "";
            handleClose();

          // }
          // Loading(0);
        }}
      >
        {({ handleSubmit,errors, touched, handleBlur, setFieldValue, values }) => (
          <Form>
            <div className="card mb-5">
              <div className="card-body">
                <div className="container-fluid mt-2 mb-2">
                  <div className="text-center text-title-color">
                    <h2>บันทึกการรับสินค้า</h2>
                  </div>
                  <br />
                  <div className="row ">
                    <div className="col-12 col-md-7">
                      {" "}
                      <div className="form-group ">
                        <label>สถานะพัสดุ</label>
                        <br />
                        <div className="form-check form-check-inline ">
                          <input
                            style={{ width: "20px", height: "20px" }}
                            className="form-check-input"
                            type="radio"
                            name="shipment_status"
                            id="shipment_status1"
                            defaultValue="1"
                            checked={shipmentStatus === "1" ? true : false}
                            onChange={(e) => {
                              setFieldValue("shipmentStatus", e.target.value);
                              handleChangeShipmentStatus(e.target.value);
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="shipment_status1"
                          >
                            1. รับเข้าระบบ
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            style={{ width: "20px", height: "20px" }}
                            className="form-check-input"
                            type="radio"
                            name="shipment_status"
                            id="shipment_status2"
                            defaultValue="2"
                            checked={shipmentStatus === "2" ? true : false}
                            onChange={(e) => {
                              setFieldValue("shipmentStatus", e.target.value);
                              handleChangeShipmentStatus(e.target.value);
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="shipment_status2"
                          >
                            2. ศูนย์กระจายคัดแยกสินค้า
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            style={{ width: "20px", height: "20px" }}
                            className="form-check-input"
                            type="radio"
                            name="shipment_status"
                            id="shipment_status3"
                            defaultValue="3"
                            checked={shipmentStatus === "3" ? true : false}
                            onChange={(e) => {
                              setFieldValue("shipmentStatus", e.target.value);
                              handleChangeShipmentStatus(e.target.value);
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="shipment_status3"
                          >
                            3. อยู่ระหว่างขนส่ง
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            style={{ width: "20px", height: "20px" }}
                            className="form-check-input"
                            type="radio"
                            name="shipment_status"
                            id="shipment_status4"
                            defaultValue="4"
                            checked={shipmentStatus === "4" ? true : false}
                            onChange={(e) => {
                              setFieldValue("shipmentStatus", e.target.value);
                              handleChangeShipmentStatus(e.target.value);
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="shipment_status4"
                          >
                            4. ส่งภายในวันนี้
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 col-md-3">
                      <div className="form-group">
                        <label htmlFor="awbCode">เลขบาร์โค้ด</label>
                        <input
                          value={values.awbCode}
                          type="text"
                          name="awbCode"
                          id="awbCode"
                          onBlur={handleBlur}
                          className={
                            "form-control " +
                            (getIn(touched, "awbCode")
                              ? getIn(errors, "awbCode")
                                ? "is-invalid"
                                : "is-valid"
                              : "") +
                            ""
                          }
                          autoComplete="offf"
                          onChange={(e) => {
                            setFieldValue("awbCode", e.target.value);
                          }}
                        />
                        <ErrorMessage
                          component="div"
                          name="awbCode"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-1 text-center mt-2">
                      <div className="form-group mt-4 ">
                        <button 
                          className="btn btn-success" 
                          type="submit"
                          // onClick={(e)=>{
                          //   // handleShow()
                          // }}
                        >
                          บันทึก
                        </button>
                      </div>
                    </div>
                  </div>

                  <hr className="mt-4 mb-4" />
                  <h4>รายการรับสินค้า</h4>
                  <FilterData
                    perPage={perPage}
                    handleChangePageSize={handleChangePageSize}
                  />
                  <ShowData
                    data={data}
                    page={page}
                    loading={loading}
                    errorMassNoData={errorMassNoData}
                    pageNo={pageNo}
                    handleChangePage={handleChangePage}
                    perPage={perPage}
                  />
                </div>
              </div>
            </div>


    {/* //modal update dimensions */}
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "19px" }}>
          <Tabs defaultActiveKey={0} 
            id="parcel-dimensions-tabs"
            activeKey={activeTab} // Controlled active tab
            onSelect={(k) => {
              setActiveTab(k)
            }}
          >
        {localStorage.getItem('role_type')=="1" || 1===1?
          values?.items?.map((value, index) => {
            const hasError = errors.items?.[index] && 
            (errors.items[index].weight || 
             errors.items[index].box_length ||
             errors.items[index].box_width ||
             errors.items[index].box_height);
             const handleKeyDown = (e, currentIndex, fieldName, handleSubmit) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                
                // Calculate next input index
                const fieldsPerItem = ['weight', 'box_length', 'box_width', 'box_height'];
                const currentFieldIndex = fieldsPerItem.indexOf(fieldName);
                let nextIndex;
                
                if (currentFieldIndex < fieldsPerItem.length - 1) {
                  // Next field in same item
                  nextIndex = currentIndex * fieldsPerItem.length + currentFieldIndex + 1;
                } else {
                  // First field of next item
                  nextIndex = (currentIndex + 1) * fieldsPerItem.length;
                }

                if(fieldName==='box_height' && currentIndex<(listDimensions.length-1)){
                  setActiveTab(currentIndex+1);
                  // alert((currentIndex + 1) * fieldsPerItem.length);
                  inputsRef.current[0].focus();
                  inputsRef.current[0].select();
                }else if(fieldName==='box_height' && currentIndex==(listDimensions.length-1)){
                  document.getElementById('buttonModalRecord').click();
                }else{
                  // Focus next input if exists
                  if (inputsRef.current[nextIndex]) {
                    inputsRef.current[nextIndex].focus();
                    inputsRef.current[nextIndex].select();
                  }
                }
              }
            };
          

            return (
            <Tab 
              key={index}
              eventKey={index}
              onEntered={
                (e)=>{
                  inputsRef.current[index*4].focus();
                  inputsRef.current[index*4].select();
                }
              }
              title={
                <div style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  color: hasError ? '#dc3545' : 'inherit'
                }}>
                  บาร์โค้ด: {value.awbCode}
                  {hasError && (
                    <span style={{ 
                      marginLeft: '5px',
                      color: '#dc3545',
                      fontWeight: 'bold'
                    }}>!</span>
                  )}
                </div>
              }
            >
            <form>
              <Modal.Title>
              {t('mis.stockIn.modal.AddDimension')} <br /> บาร์โค้ด : {value.awbCode}
              </Modal.Title>
            
            <div className="form-group">
              <label>{t('mis.stockIn.modal.weight')}</label>
              <input
                ref={el => inputsRef.current[index * 4 + 0] = el} // weight
                onKeyDown={(e) => handleKeyDown(e, index, 'weight',handleSubmit)}
                onFocus={(event)=>{
                  event.target.select();
                }}
                value={value.weight}
                min={0.1}
                type="number"
                name="weight"
                id="weight"
                onBlur={handleBlur}
                className={
                  "form-control " +
                  (getIn(touched, "weight")
                    ? getIn(errors, "weight")
                      ? "is-invalid"
                      : "is-valid"
                    : "") +
                  ""
                }
                autoComplete="offf"
                onChange={(e) => {
                  setFieldValue(`items.${index}.weight`, e.target.value);
                  // SetListDimensions(items[index].)
                  // alert(e.target.value);
                }}
              />
              <ErrorMessage
                component="div"
                name="weight"
                className="invalid-feedback"
              />
            </div>
            <div className="form-group">
              <label>{t('mis.stockIn.modal.length')}</label>
              <input
                ref={el => inputsRef.current[index * 4 + 1] = el} // box_length
                onKeyDown={(e) => handleKeyDown(e, index, 'box_length',handleSubmit)}
                value={value.box_length}
                onFocus={(event)=>{
                  event.target.select();
                }}
                min={1}
                type="number"
                name="length"
                id="length"
                onBlur={handleBlur}
                className={
                  "form-control " +
                  (getIn(touched, "length")
                    ? getIn(errors, "length")
                      ? "is-invalid"
                      : "is-valid"
                    : "") +
                  ""
                }
                autoComplete="offf"
                onChange={(e) => {
                  setFieldValue(`items.${index}.box_length`, e.target.value);
                }}
              />
              <ErrorMessage
                component="div"
                name="length"
                className="invalid-feedback"
              />
            </div>
            <div className="form-group">
              <label>{t('mis.stockIn.modal.width')}</label>
              <input
                ref={el => inputsRef.current[index * 4 + 2] = el} // box_width
                onKeyDown={(e) => handleKeyDown(e, index, 'box_width',handleSubmit)}
                value={value.box_width}
                onFocus={(event)=>{
                  event.target.select();
                }}
                min={1}
                type="number"
                name="width"
                id="width"
                onBlur={handleBlur}
                className={
                  "form-control " +
                  (getIn(touched, "width")
                    ? getIn(errors, "width")
                      ? "is-invalid"
                      : "is-valid"
                    : "") +
                  ""
                }
                autoComplete="offf"
                onChange={(e) => {
                  setFieldValue(`items.${index}.box_width`, e.target.value);
                }}
              />
              <ErrorMessage
                component="div"
                name="width"
                className="invalid-feedback"
              />
            </div>
            <div className="form-group">
              <label>{t('mis.stockIn.modal.height')}</label>
              <input
                ref={el => inputsRef.current[index * 4 + 3] = el} // box_height
                onKeyDown={(e) => handleKeyDown(e, index, 'box_height',handleSubmit)}
                value={value.box_height}
                onFocus={(event)=>{
                  event.target.select();
                }}
                min={1}
                type="number"
                name="height"
                id="height"
                onBlur={handleBlur}
                className={
                  "form-control " +
                  (getIn(touched, "height")
                    ? getIn(errors, "height")
                      ? "is-invalid"
                      : "is-valid"
                    : "") +
                  ""
                }
                autoComplete="offf"
                onChange={(e) => {
                  setFieldValue(`items.${index}.box_height`, e.target.value);
                }}
              />
              <ErrorMessage
                component="div"
                name="height"
                className="invalid-feedback"
              />
            </div>
          </form>
          </Tab>
          )
          }
          ):("")
        }
        </Tabs>
        </Modal.Body>
        {1===1?(
          <Modal.Footer>
          <button
            // disabled={localStorage.getItem('role_type')=="21" || localStorage.getItem('role_type')=='21'?"true":"false"}
            id="buttonModalRecord"
            type="submit"
            className="btn btn-primary"
            onClick={(e) => {
              //update dimensions and status
              // alert(JSON.stringify(values))
              updateDimensionsMultiple(values);
              insertData(values);
              values.awbCode = ""
              document.getElementById("awbCode").value = "";
              handleClose();
              // loading(0)
            }}
          >
          {/* save */}
          {t('mis.stockIn.modal.record')}
          </button>
          {/* อัพโหลดรูป */}
          </Modal.Footer>

        ):("")

        }

      </Modal>
          </Form>
        )}
      </Formik>
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.Authentication,
});

export default connect(mapStateToProps)(SaveGoods);
